<template>
	<!-- <footer>
		 <div class="footer_container">
			<p class="copyright">ⓒ {{ $t('rtr_footer.text1') }}</p>
			<div v-if="0" class="footer_link">
				<ul>
					<li><router-link to @click="notYet">About</router-link></li>
					<li><router-link :to="{ name: 'terms' }">Privacy</router-link></li>
					<li><router-link :to="{ name: 'cookies' }">Cookies</router-link></li>
				</ul>
			</div>
		</div>
	</footer> -->
	<footer class="footer_sec">
		<div class="footer_up">
			<div class="container">
				<div class="row">
					<div class="col-sm-3">
						<div class="footer_inn">
							<img style="width: 200px" :src="img.image26" alt="" />
							<div class="footer_lt">
								<h6>Office Address</h6>
								<p>39 Namdaemun-Ro, Jung <br />District, Seoul, South Korea.</p>
							</div>
							<div class="footer_lt">
								<h6>Connect With Us</h6>
								<p>
									<img :src="img.image27" alt="" />
									<a href="tel:8228522548">+82 2-852-2548</a>
								</p>
								<p>
									<img :src="img.image28" alt="" />
									<a href="https://wa.me/8228522548">+82 2-852-2548</a>
								</p>
								<p>
									<img :src="img.image29" alt="" />
									<a href="mailto:support@jpworldpay.com"
										>support@jpworldpay.com</a
									>
								</p>
								<p>
									<img :src="img.image30" alt="" />
									<a href="mailto:support@jpworldpay.com"
										>info@jpworldpay.com</a
									>
								</p>
							</div>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="footer2">
							<h6>Individual</h6>
							<ul>
								<li><a href="/online-shopping">Online Shopping</a></li>
								<li><a href="">Offline Kiosk</a></li>
								<li><a href="">Pay With QR Code</a></li>
								<li><a href="">Transaction & Cashback</a></li>
								<li><a href="">Send Asset</a></li>
								<li><a href="">Asset Request</a></li>
								<li><a href="">Get A Deposit</a></li>
								<li><a href="">Fee</a></li>
								<li><a href="">Wallet</a></li>
								<li><a href="">Account</a></li>
								<li><a href="">Sell</a></li>
								<li><a href="">Exchanging Currency</a></li>
							</ul>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="footer2">
							<h6>Business</h6>
							<ul>
								<li><a href="">Getting Started</a></li>
								<li><a href="">Accepting Payment</a></li>
								<li><a href="">Make A Payment</a></li>
								<li><a href="">Risk Management</a></li>
								<li><a href="">About Company</a></li>
								<li><a href="">Platforms & Features</a></li>
								<li><a href="">Payment Method</a></li>
								<li><a href="">Global Payment Processing</a></li>
							</ul>

							<div class="follw_us">
								<h6>Follow Us</h6>
								<ul>
									<li>
										<a href=""><i class="fa-brands fa-facebook-f"></i></a>
									</li>
									<li>
										<a href=""><i class="fa-brands fa-x-twitter"></i></a>
									</li>
									<li>
										<a href=""><i class="fa-brands fa-linkedin-in"></i></a>
									</li>
									<li>
										<a href=""><i class="fa-brands fa-youtube"></i></a>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="footer2">
							<h6>Other Links</h6>
							<ul>
								<li><a href="">About JPWorldPay</a></li>
								<li><a href="">Get a deposit</a></li>
								<li><a href="">Development</a></li>
								<li><a href="">Customer Service</a></li>
								<li><a href="">Testimonial</a></li>
								<li><a href="">Contact Us</a></li>
							</ul>
						</div>

						<div class="footer2 footer3">
							<h6>Terms & Policy</h6>
							<ul>
								<li><a href="">Privacy Policy</a></li>
								<li><a href="">Cookies Policy</a></li>
								<li><a href="">Terms & Conditions</a></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mob_footer">
			<div class="accordion" id="accordionExample">
				<div class="accordion-item">
					<h2 class="accordion-header" id="headingOne">
						<button
							class="accordion-button"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#collapseOne"
							aria-expanded="true"
							aria-controls="collapseOne"
						>
							<img :src="img.image26" alt="" />
						</button>
					</h2>
					<div
						id="collapseOne"
						class="accordion-collapse collapse show"
						aria-labelledby="headingOne"
						data-bs-parent="#accordionExample"
					>
						<div class="accordion-body">
							<div class="container">
								<div class="row">
									<div class="col-sm-3">
										<div class="footer_inn">
											<div class="footer_lt">
												<h6>Office Address</h6>
												<p>
													39 Namdaemun-Ro, Jung <br />District, Seoul, South
													Korea.
												</p>
											</div>
											<div class="footer_lt">
												<h6>Connect With Us</h6>
												<p>
													<img :src="img.image27" alt="" />
													<a href="tel:8228522548">+82 2-852-2548</a>
												</p>
												<p>
													<img :src="img.image28" alt="" />
													<a href="https://wa.me/8228522548">+82 2-852-2548</a>
												</p>
												<p>
													<img :src="img.image29" alt="" />
													<a href="mailto:support@jpworldpay.com"
														>support@jpworldpay.com</a
													>
												</p>
												<p>
													<img :src="img.image30" alt="" />
													<a href="mailto:support@jpworldpay.com"
														>info@jpworldpay.com</a
													>
												</p>
											</div>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="footer2">
											<h6>Individual</h6>
											<ul>
												<li><a href="/online-shopping">Online Shopping</a></li>
												<li><a href="">Offline Kiosk</a></li>
												<li><a href="">Pay With QR Code</a></li>
												<li><a href="">Transaction & Cashback</a></li>
												<li><a href="">Send Asset</a></li>
												<li><a href="">Asset Request</a></li>
												<li><a href="">Get A Deposit</a></li>
												<li><a href="">Fee</a></li>
												<li><a href="">Wallet</a></li>
												<li><a href="">Account</a></li>
												<li><a href="">Sell</a></li>
												<li><a href="">Exchanging Currency</a></li>
											</ul>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="footer2">
											<h6>Business</h6>
											<ul>
												<li><a href="">Getting Started</a></li>
												<li><a href="">Accepting Payment</a></li>
												<li><a href="">Make A Payment</a></li>
												<li><a href="">Risk Management</a></li>
												<li><a href="">About Company</a></li>
												<li><a href="">Platforms & Features</a></li>
												<li><a href="">Payment Method</a></li>
												<li><a href="">Global Payment Processing</a></li>
											</ul>

											<div class="follw_us deskfollow">
												<h6>Follow Us</h6>
												<ul>
													<li>
														<a href=""
															><i class="fa-brands fa-facebook-f"></i
														></a>
													</li>
													<li>
														<a href=""
															><i class="fa-brands fa-x-twitter"></i
														></a>
													</li>
													<li>
														<a href=""
															><i class="fa-brands fa-linkedin-in"></i
														></a>
													</li>
													<li>
														<a href=""><i class="fa-brands fa-youtube"></i></a>
													</li>
												</ul>
											</div>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="footer2">
											<h6>Other Links</h6>
											<ul>
												<li><a href="">About JPWorldPay</a></li>
												<li><a href="">Get a deposit</a></li>
												<li><a href="">Development</a></li>
												<li><a href="">Customer Service</a></li>
												<li><a href="">Testimonial</a></li>
												<li><a href="">Contact Us</a></li>
											</ul>
										</div>

										<div class="footer2 footer3">
											<h6>Terms & Policy</h6>
											<ul>
												<li><a href="">Privacy Policy</a></li>
												<li><a href="">Cookies Policy</a></li>
												<li><a href="">Terms & Conditions</a></li>
											</ul>
										</div>
										<div class=""></div>
									</div>
									<div class="col-sm-12 mobfollow">
										<div class="footer2">
											<div class="follw_us deskmod">
												<h6>Follow Us</h6>
												<ul>
													<li>
														<a href=""
															><i class="fa-brands fa-facebook-f"></i
														></a>
													</li>
													<li>
														<a href=""
															><i class="fa-brands fa-x-twitter"></i
														></a>
													</li>
													<li>
														<a href=""
															><i class="fa-brands fa-linkedin-in"></i
														></a>
													</li>
													<li>
														<a href=""><i class="fa-brands fa-youtube"></i></a>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="footer_dwn">
			<div class="container">
				<div class="row">
					<div class="col-sm-12">
						<p>ⓒ JPWorldPay. All Rights Reserved.</p>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import footerlogo from '@/assets/images/sub/footerlogo_white.png';
import phncall from '@/assets/images/sub/Call.png';
import whtsp from '@/assets/images/sub/WhatsApp.png';
import mail from '@/assets/images/sub/Mail.png';

export default {
	data: () => ({
		img: {
			image26: footerlogo,
			image27: phncall,
			image28: whtsp,
			image29: mail,
			image30: mail,
		},
	}),

	name: 'Footer',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>
